/**
 * MediaPreprocessor is responsible for optimizing media
 * before they are converted to PIXI textures
 */
export default {
  /**
   * Render image on resized canvas to reduce render time for large images
   */
  scaleOutOfBoundsImage(app, image) {
    let resizedImage = image;
    const scale = Math.max(
      app.screen.height / image.height,
      app.screen.width / image.width
    );
    if (scale < 1) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = image.width * scale;
      canvas.height = image.height * scale;
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
      resizedImage = canvas;
    }
    return resizedImage;
  },
};
